import React from 'react'

class Orderhandler extends React.Component {


    
    
    

    // test = this.props.orders.reduce((acc, {id, orders}) => {
    //     if(!acc[id]) acc[id] = [];
    //     acc[id].push(orders)
    //     return acc
    // }, {})
    
        
    render(){
        
 
        // console.log(this.props.orders.id
        // )
    //    console.log(this.test)
        return (
            <div>
                {/* Hello from order handler */}
                {/* {this.test} */}
            </div>
        )
    }
}

export default Orderhandler